import { clearStores, logout } from '../../stores/user/user-actions';
import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import getClassNames from 'classnames';
import docCookies from '../../utils/docCookie';


// Components
import Icon from '../tc-ui/icon';
import { Avatar, Popover, ListItem, Divider } from 'material-ui';
import R from 'ramda';

const propTypes = {
  companySlugName: PropTypes.string,
  dispatch: PropTypes.func,
  user: PropTypes.object,
  className: PropTypes.string,
  profile: PropTypes.object,
  showOnboardingAppBar: PropTypes.bool,
};
class ProfileLink extends React.Component {
  constructor() {
    super();
    this.state = { open: false };
  }

  togglePopover = e => {
    this.setState({
      open: e ? !this.state.open : false,
      anchorEl: e ? e.currentTarget : null,
    });
  };

  closePopover = () => {
    this.setState({ open: false });
  };

  _handleLogOut = () => {
    const { dispatch } = this.props;
    if (docCookies.hasItem('isAnAdmin')) docCookies.removeItem('isAnAdmin', '/', `${window.location.host.split('.')[1]}.com`);
    const actions = [clearStores, logout].map(action => dispatch(action()));
    // actions[1].then(() => {
      // window.location = `${window.location.protocol}//${window.location.host}/signin`;
    // });
  };

  dispatchedPush = (...args) => {
    this.setState({ open: false });
    this.props.dispatch(push(...args));
  }

  render() {
    const { user } = this.props;
    const { allApps } = user;
    const billingEnabled = user.company.billingEnabled;
    const dropdownUrls = {
      accountSettingsUrl: '/settings',
      supportUrl: 'http://support.tourconnect.com',
      communityUrl: 'https://community.tourconnect.com/session/sso',
      logOutUrl: `${window.location.protocol}//${window.location.host}/signin`,
      loginAdminUrl: `${window.location.protocol}//${window.location.host}/admin/company-details/${user.user.userID}`,
    };

    const classes = getClassNames('profile-link', this.props.className);

    const loginAdminUrl = dropdownUrls.loginAdminUrl || '/';
    const imageUrl = user.company.profileImageUrl || '';

    const integrationAvailable = Boolean(user.user.type === 'Contractor' && user.company.tourplan);
    if (this.props.showOnboardingAppBar) return <a href={dropdownUrls.logOutUrl} onClick={this._handleLogOut} style={{ float: 'right', position: 'relative', top: '24px' }}>{'Log Out'}</a>;
    return (
      <div className={classes}>
        <div className="profile-link-target" onClick={this.togglePopover}>
          {imageUrl ? <Avatar style={{ top: '10px', position: 'relative' }} src={imageUrl} />
            : <Avatar style={{ top: '10px', position: 'relative' }}>{R.head(user.company.companyName)}</Avatar>}
          <Icon className="profile-link-dropdown-arrow tc-icon-arrow-drop-down" />
        </div>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this.closePopover}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          {
            allApps && allApps.indexOf('s&m') > -1 && (
              <ListItem
                style={{ padding: '16px' }}
                leftAvatar={imageUrl ? <Avatar style={{ border: '1px solid #e0e0e0' }} src={imageUrl} /> : <Avatar>{R.head(user.company.companyName)}</Avatar>}
                primaryText="View Profile"
                onTouchTap={() => this.dispatchedPush('/profile')}
              />
            )
          }
          <div>
            <Divider/>
            {
              integrationAvailable && (
                <ListItem
                  desktop
                  style={{ fontSize: '14px' }}
                  primaryText="Integration"
                  onTouchTap={() => this.dispatchedPush(Object.keys(user.company.tourplan).length === 3 ? '/integration/contracts' : '/integration/authentication')}
                />
              )
            }
            {integrationAvailable && <Divider/>}
            <ListItem
              desktop
              style={{ fontSize: '14px' }}
              primaryText="My Settings"
              onTouchTap={() => this.dispatchedPush('/settings/my-settings')}
            />
            <ListItem
              desktop
              style={{ fontSize: '14px' }}
              primaryText="Company Settings"
              onTouchTap={() => this.dispatchedPush('/settings/company-settings')}
            />
            {
              billingEnabled && (
                <ListItem
                  desktop
                  style={{ fontSize: '14px' }}
                  primaryText="Billing Settings"
                  onTouchTap={() => this.dispatchedPush('/settings/billing')}
                />
              )
            }
            <Divider/>
            <ListItem
              desktop
              style={{ fontSize: '14px' }}
              primaryText="Support"
              onTouchTap={() => window.location = (dropdownUrls.supportUrl)}
            />
            <ListItem
              desktop
              style={{ fontSize: '14px' }}
              primaryText="Community"
              onTouchTap={() => window.location = (dropdownUrls.communityUrl)}
            />
            <Divider/>
            <ListItem
              desktop
              style={{ fontSize: '14px' }}
              primaryText="Log Out"
              onTouchTap={this._handleLogOut}
            />
            {
              user.isAnAdmin && (<ListItem
                desktop
                style={{ fontSize: '14px' }}
                primaryText="Back to Admin"
                onTouchTap={() => window.location = loginAdminUrl}
              />)
            }
          </div>
        </Popover>
      </div>
    );
  }
}
ProfileLink.contextTypes = {
  router: PropTypes.object.isRequired,
};
ProfileLink.propTypes = propTypes;
export default ProfileLink;



// WEBPACK FOOTER //
// ./src/app/components/app-bar/profile-link.jsx